import { createPortal } from 'react-dom'
import React from 'react'
import { DragLayer, DragLayerMonitor } from 'react-dnd'
import EmployeeDragPreview from './EmployeeDragPreview'
import css from './adminFloorPlan.module.scss'

function getItemStyles(currentOffset: { x: number; y: number }) {
  if (!currentOffset) {
    return {
      display: 'none',
    }
  }

  const { x, y } = currentOffset
  const transform = `translate(${x}px, ${y - 18}px)`
  return {
    transform: transform,
    WebkitTransform: transform,
    width: 'fit-content',
  }
}

function CustomDragLayer({ item, isDragging, currentOffset }: any) {
  if (!isDragging) {
    return null
  }

  return createPortal(
    <div className={css.drag_layer_container}>
      <div style={getItemStyles(currentOffset)}>
        <EmployeeDragPreview employee={item.data} />
      </div>
    </div>,
    document.body
  )
}

function collect(monitor: DragLayerMonitor) {
  return {
    item: monitor.getItem(),
    currentOffset: monitor.getClientOffset(),
    // currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }
}

export default DragLayer(collect)(CustomDragLayer)
